
















































import { cloneDeep } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import {
  PlaceholdersOnes,
  PlaceholdersStack,
  PlaceholdersType
} from '../../../../../../../../Editor/components/Toolbar/types'
import MultiMessageEditorWithMediaInput
  from '../../../../../../../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import SelectInput from '../../../../../../../../Pi/fields/SelectInput/SelectInput.vue'
import { FieldData, SelectOptionData } from '../../../../../../../../Pi/types'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { InfoLimitedSubscriptionNode } from '../../logic/InfoLimitedSubscriptionNode'

@Component({
  components: {
    MultiMessageEditorWithMediaInput,
    SelectInput,
  },
})
export default class InfoLimitedSubscriptionSidebar extends Vue {
  @Prop() node!: InfoLimitedSubscriptionNode

  @Prop() editor!: CustomEditor

  placeholders: PlaceholdersOnes | PlaceholdersStack | null = null

  get targets(): Array<SelectOptionData> {
    return this.node.nodeProps.targets().map((t) => {
      return {
        label: t.title,
        value: t.id,
      }
    })
  }

  setMessages(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setMessages(val, this.editor)
    return arg
  }

  setTarget(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setTarget(val)
    return arg
  }

  created(): void {
    const infoLimitedPlaceholders = [
      {
        label: this.$t('flow_placeholder_end_subscription_date_time').toString(),
        value: '{enddatetime}'
      },
      {
        label: this.$t('flow_placeholder_join_link').toString(),
        value: '{joinlink}',
        description: this.$t('flow_placeholder_join_link_description').toString()
      }
    ]

    const placeholders = typeof this.node.nodeProps.placeholders === 'function' ? cloneDeep(this.node.nodeProps.placeholders()) : {
      type: PlaceholdersType.Ones,
      placeholders: infoLimitedPlaceholders
    } as PlaceholdersOnes

      if (placeholders.type === PlaceholdersType.Stack) {
        placeholders.placeholders[0].sections.push({
          buttonTitle: this.$t('flow_info_limited_subscription_node_name').toString(),
          placeholders: infoLimitedPlaceholders
        })
      } else {
        placeholders.placeholders.push(...infoLimitedPlaceholders)
      }

      this.placeholders = placeholders
  }
}
